/* eslint-disable no-unused-vars */
/* eslint-disable no-multi-assign */
/* eslint-disable func-names */
import cookies from './cookies';

const initializeFreshbots = (route, meData, supportMeData) => {
  const { me } = meData;
  (function (d, w, c) {
    if (!d.getElementById('spd-busns-spt')) {
      const n = d.getElementsByTagName('script')[0];
      const s = d.createElement('script');
      let loaded = false;
      s.id = 'spd-busns-spt';
      s.async = 'async';
      s.setAttribute('data-self-init', 'false');
      s.setAttribute('data-init-type', 'opt');
      s.src = 'https://cdn.in-freshbots.ai/assets/share/js/freshbots.min.js';
      s.setAttribute('data-client', process.env.FRESHBOT_CLIENT_KEY);
      s.setAttribute('data-bot-hash', process.env.FRESHBOT_HASH_KEY);
      s.setAttribute('data-env', 'prod');
      s.setAttribute('data-region', 'in');
      if (c) {
        s.onreadystatechange = s.onload = function () {
          if (!loaded) {
            c();
          }
          loaded = true;
        };
      }
      n.parentNode.insertBefore(s, n);
    }
  })(document, window, function () {
    if (!window.Freshbots) {
      initializeFreshbots(route, meData, supportMeData);
    } else if (meData.isLoggedIn || me.uid) {
      window.Freshbots.initiateWidget(
        {
          autoInitChat: false,
          getClientParams() {
            return {
              'cstmr::xtrInfrmtn:api_server_token': meData.accessToken,
              'sn::cstmr::id': me.uid,
              'cstmr::xtrInfrmtn:jwt_token': me.jwtToken,
              'cstmr::eml': supportMeData?.gen_email_id,
              is_logged_in: meData.isLoggedIn,
              xtrnlTcktId: '',
              goal_uid: meData.selectedGoal,
              is_anonymous: !meData.isLoggedIn,
              'cstmr::phn': me.phone,
              'cstmr::nm': me.name,
              android_device: cookies.readCookie('device') || '',
              source: route === '/support' ? 'android' : 'web',
              android_app_version: cookies.readCookie('OSVersion') || '',
              android_os_version: cookies.readCookie('appVersionName') || '',
              browser: '',
              browser_version: '',
              portal: 'plus'
            };
          }
        },
        function (successResponse) {
          if (route === '/support') {
            window.Freshbots.showWidget(true);
            document.getElementById('fbots-wdgt').style.width = '100vw';
            document.getElementById('fbots-wdgt').style.right = '0px';
            document.getElementById('fbots-wdgt').style.left = '0px';
            document.getElementById('fbots-wdgt').style.top = '0px';
            document.getElementById('fbots-wdgt').style.bottom = '0px';
            document.getElementById('fbots-wdgt').style.maxHeight = 'none';
            document.getElementById('fbots-wdgt').style.display = 'block';
          }
        },
        function (errorResponse) {
          /* TODO:- @priya remove eslint-disable no-unused-vars from file once successResponse and errorResponse is used */
        }
      );
    }
  });
};

export default initializeFreshbots;
